// Server timestamps come from MongoDB as UTC without a zone marker ("2026-10-18T23:12:01.123000").
// Browsers would read those as local time, so treat precise (fractional-second) naive ISO strings as UTC.
// Date-only values and datetime-local inputs (no fractional seconds) are left alone.
const NativeDate = Date;
const NAIVE_UTC = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+$/;
const fix = (v) => (typeof v === 'string' && NAIVE_UTC.test(v) ? `${v}Z` : v);

function UtcAwareDate(...args) {
  if (!new.target) return NativeDate();
  if (args.length === 1) args[0] = fix(args[0]);
  return new NativeDate(...args);
}
UtcAwareDate.prototype = NativeDate.prototype;
Object.setPrototypeOf(UtcAwareDate, NativeDate);
UtcAwareDate.parse = (s) => NativeDate.parse(fix(s));

window.Date = UtcAwareDate;
